import axiosInstance from "../../api/axiosConfig";

export const getCartList = () => {
  return axiosInstance.get("/cart");
};

export const deleteCart = (id: string) => {
  return axiosInstance.delete(`/cart/${id}`);
};

export const placeOrder = () => {
  return axiosInstance.post("/orders/place-order");
};
